<script setup lang="ts">
import { withoutTrailingSlash } from 'ufo'

const route = useRoute()

const { data: partner } = await useAsyncData(useRoute().path, () => queryCollection('partners').path(useRoute().path).first())
if (!partner.value) {
  throw createError({ statusCode: 404, fatal: true })
}

const { data: surround } = await useAsyncData(`${route.path}-surround`, () => queryCollectionItemSurroundings('partners', route.path, {
  fields: ['title', 'description'],
}))

useSeoMeta({
  title: partner.value.title ?? null,
  description: partner.value.description ?? null,
})

</script>

<template>
  <UContainer v-if="partner">
    <UPageHeader
        :title="partner.title"
        :description="partner.description"
    >
      <template #headline>
        <UBreadcrumb :items="[{label: 'Partenaires', to: '/partenariat'}]" />
      </template>
    </UPageHeader>

    <UPage>
      <UPageBody>
        <NuxtImg :src="`${partner.path}.jpg`" class="max-w-md" />
        <ContentRenderer
            v-if="partner && partner.body"
            :value="partner"
        />

        <UButton :to="partner.to" target="_blank" external :rel="`${partner.path === '/partenariat/livemento' ? '' : 'nofollow '}noopener noreferrer`">Découvrir notre partenaire</UButton>

        <USeparator v-if="surround?.length" />

        <UContentSurround :surround="surround" />
      </UPageBody>
    </UPage>
  </UContainer>
</template>